module.exports = __webpack_public_path__ + "img/IOS_wordmark_(2017) 2.9e7f4b02.svg";